// Thin wrapper around the Umami global so callers don't have to worry about
// the `defer`-loaded script not being ready yet. On a fresh page load the
// script may not have parsed by the time the user store rehydrates an
// already-authenticated session — we poll briefly, then give up.

interface UmamiGlobal {
  identify: (id: string, traits?: Record<string, unknown>) => void
  track?: (eventName: string, data?: Record<string, unknown>) => void
}

declare global {
  interface Window {
    umami?: UmamiGlobal
  }
}

const MAX_WAIT_MS = 5000
const POLL_INTERVAL_MS = 150

function whenUmamiReady(cb: (u: UmamiGlobal) => void) {
  if (typeof window === 'undefined') return
  if (window.umami) {
    cb(window.umami)
    return
  }
  const start = Date.now()
  const interval = window.setInterval(() => {
    if (window.umami) {
      window.clearInterval(interval)
      cb(window.umami)
    } else if (Date.now() - start > MAX_WAIT_MS) {
      window.clearInterval(interval)
    }
  }, POLL_INTERVAL_MS)
}

export function identifyUser(id: string, traits: Record<string, unknown> = {}) {
  whenUmamiReady((u) => u.identify(id, traits))
}
